import { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-50 no-underline group"
          >
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
              漫
            </div>
            <span className="text-lg font-heading font-bold tracking-wide whitespace-nowrap">
              <span className="text-primary-500">韩漫</span>漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {[
              { to: "/", label: "首页" },
              { to: "/category/all", label: "分类" },
              { to: "/category/romance", label: "恋爱" },
              { to: "/category/fantasy", label: "奇幻" },
              { to: "/category/action", label: "动作" },
              { to: "/about", label: "关于我们" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`relative px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                  location.pathname === item.to
                    ? "text-primary-500 bg-primary-500/10"
                    : "text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="relative w-9 h-9 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50 transition-all duration-200 cursor-pointer">
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className="relative w-9 h-9 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50 transition-all duration-200 cursor-pointer">
              <i className="ri-bookmark-line text-lg"></i>
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden relative w-9 h-9 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50 transition-all duration-200 cursor-pointer"
            aria-label="菜单"
          >
            <i
              className={`text-xl ${
                isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"
              }`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/50">
          <div className="px-4 py-3 flex flex-col gap-1">
            {[
              { to: "/", label: "首页" },
              { to: "/category/all", label: "全部分类" },
              { to: "/category/romance", label: "恋爱" },
              { to: "/category/fantasy", label: "奇幻" },
              { to: "/category/action", label: "动作" },
              { to: "/category/thriller", label: "悬疑" },
              { to: "/category/comedy", label: "搞笑" },
              { to: "/about", label: "关于我们" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                  location.pathname === item.to
                    ? "text-primary-500 bg-primary-500/10"
                    : "text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}